import { parse } from 'querystring';
import { cookies as cookiesList } from '@catalogo/core-cookies';
import { getDevice } from '@catalogo/shell-web/src/server/helpers/device';
import { Config } from '@catalogo/core-configuration';
import { PageLoadEvent } from '../../types/events';
import { GenericDatalayerEvent } from '../../types/datalayer/generic';
import { PAGETYPES } from '../../types/datalayer/datalayer';

export default (pageload: PageLoadEvent, config: Config): GenericDatalayerEvent => {
  const parsedQs = parse(window.location.search.replace('?', ''));
  const { type, slug } = pageload.detail?.page;
  const pagetype = PAGETYPES[type] || type;

  const brand = config.brand.toUpperCase();
  const cookies = cookiesList.getAll();
  const device = getDevice();
  const epar = cookies.b2wEPar || '';
  const eparElements = epar.split('_');
  const pagename = !slug ? `${brand}:${pagetype}` : `${brand}:${pagetype}:${slug}`;

  return {
    AppID: device === 'mobile' ? 'MOBILESITE' : 'NAOMOBILE',
    b2wChannel: cookies.b2wChannel,
    'b2w-pid': cookies['B2W-PID'],
    b2wRegion: cookies.b2wRegion,
    'b2w-sid': cookies['B2W-SID'],
    'b2w-uid': cookies['B2W-UID'],
    campanha: eparElements.slice(4).join('_'),
    cep: cookies.persistentCep,
    cfinance: cookies.c_finance,
    chave: cookies.b2wChave,
    epar,
    formato: eparElements[1],
    franq: cookies.b2wFranq,
    gclid: parsedQs?.gclid,
    marca: brand,
    msclkid: parsedQs?.msclkid,
    midia: eparElements[0],
    opn: cookies.b2wOpn,
    page: document.location.pathname,
    pagename,
    pagetype,
    parceiro: eparElements[3],
    referrer: document.referrer || undefined,
    region: `${cookies.mesoRegion}, ${cookies.macroRegion}, ${cookies.legionRegion}`,
    subformato: eparElements[2],
    title: document.title,
    url: window.location.href,
    'versão-site': 'Responsivo',
    canonical: pageload?.detail?.page?.canonical,
  } as GenericDatalayerEvent;
};
